<template>
	<div class="loadDimensions">
		<div class="title">Dimensions</div>
		<div class="wrapInputs">
			<field
					margin="0"
					label="Width"
					type="number"
					@updateInput="onInput($event, 'width_from', 'dimonsions')"
					:setInputValue="load.dimonsions.width_from"
			></field>
			<field
					margin="0"
					label="Length"
					type="number"
					@updateInput="onInput($event, 'length_from', 'dimonsions')"
					:setInputValue="load.dimonsions.length_from"
			></field>
			<field
					margin="0"
					label="Height"
					type="number"
					@updateInput="onInput($event, 'height_from', 'dimonsions')"
					:setInputValue="load.dimonsions.height_from"
			></field>
			<field
					margin="0"
					label="Quantity"
					type="number"
					@updateInput="onInput($event, 'quantity')"
					:setInputValue="load.quantity"
			></field>
			<field
					margin="0"
					label="Weight"
					type="number"
					@updateInput="onInput($event, 'weight')"
					:setInputValue="load.weight"
			></field>
			<field
					margin="0"
					label="Special instructions"
					placeholder="Enter special instructions"
					@updateInput="onInput($event, 'special_instructions')"
					:setInputValue="load.special_instructions"
			></field>
		</div>
		<div class="wrapSwitch">
			<field
					margin="0"
					@updateSwitch="onSwitch($event, 'tonu')"
					:switch-value="!!load.tonu"
					is-switch
					is-dense
					label-switch="TONU"
			></field>
			<field
					margin="0"
					@updateSwitch="onSwitch($event, 'tarp')"
					:switch-value="!!load.tarp"
					is-switch
					is-dense
					label-switch="Tarp"
			></field>
			<field
					v-if="load.customer_billing"
					margin="0"
					@updateSwitch="onSwitch($event, 'billing_switch')"
					:switch-value="!!load.billing_switch"
					is-switch
					is-dense
					label-switch="Billing"
			></field>
			<div class="billingService">
				<span class="text">Billing service:</span>
				<span :class="{'active': load.customer_billing}">{{ getBillingService }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Dimensions",
	props: {
		load: Object,
	},
	computed: {
		getBillingService() {
			return this.load.customer_billing ? 'Active' : 'Not active';
		},
	},
	methods: {
		onInput({ value }, key, parent) {
			this.$emit('updateInput', { value, key, parent });
		},
		onSwitch({ value }, key) {
			this.$emit('updateSwitch', { value, key });
		},
	},
};
</script>

<style scoped lang="scss">
@import "loadDimensions";
</style>
